import { useEffect, useState } from "react"
import { required, useDataStore, useQuery, useRetainedEntities } from "../../Data"
import type { INoteAttachment } from "../../Types"
import { SchemaEntities } from "../../Types/Generated/LogbookModel/Schema"

export function useShipAttachments(shipId: number | undefined): INoteAttachment[] | undefined {
  const store = useDataStore();
  const attachments = useQuery(store, SchemaEntities.NoteAttachment, {
    shipId: required(shipId),
    noteId: 0,
  });
  const [loaded, setLoaded] = useState(false);
  useRetainedEntities([SchemaEntities.NoteAttachment], shipId !== undefined, shipId);

  useEffect(() => {
    if (shipId === undefined) {
      setLoaded(false);
      return;
    }
    if (store.isQueryFetched(SchemaEntities.NoteAttachment, { shipId, noteId: 0 })) {
      setLoaded(true);
      return;
    }
    store.fetchQuery(SchemaEntities.NoteAttachment, { shipId, noteId: 0 }).then(() => {
      if (store.isQueryFetched(SchemaEntities.NoteAttachment, { shipId, noteId: 0 })) {
        setLoaded(true);
      }
    });
  }, [shipId, store]);

  return loaded ? [...attachments] : undefined;
}
